import { Bank } from "../dtos";
import { BaseEndpoint } from "./BaseEndpoint";
import { WithGetAll } from "./mixins/WithGetAll";

export class Endpoint extends BaseEndpoint("banks") {}

export const BankEndpoint = WithGetAll<typeof Endpoint, Bank>(Endpoint);
